import { Injectable } from '@angular/core';
import { UserInfo } from '../../models/common/UserInfo';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {

  private _userInfo: UserInfo;
  public get userInfo(): UserInfo {
    return this._userInfo;
  }
  public set userInfo(v: UserInfo) {
    this._userInfo = v;
  }


}
